// extracted by mini-css-extract-plugin
export default {"MessagesContainer":"Messages_MessagesContainer__cvXcb"};